module.exports = __webpack_public_path__ + "img/Mom-icons_Website Stats.30bddb0a.png";